import { User } from './user';

export enum ScriptStatus {
  LOADED = 'Loaded',
  ALREADY_LOADED = 'Already Loaded',
  ERROR = 'Error'
}

export interface ScriptLoad {
  scriptName: string,
  loaded: boolean,
  status: string
}


